
import { put, call, takeEvery, select, takeLatest } from 'redux-saga/effects';
import * as actions from './actions';
import { Endpoints } from 'services/api';
import errorHandler from 'common/errorHandler';

function* getEventApiKey(api, eventId, apiKeyId) {
    try {
        let result = yield call([api, api.get], `${Endpoints.events}/api/v1/events/${eventId}/apikeys/${apiKeyId}`);
        return result.data;
    }
    catch (error) {
        if (error.isAxiosError) {
            if (error.response && error.response.status === 404) {
                return null;
            }
        }
        throw error;
    }
}

export function* getEventApiKeyRequest(api, { eventId, apiKeyId }) {
    try {
        const apiKeyRevision = yield call(getEventApiKey, api, eventId, apiKeyId);
        yield put(actions.getEventApiKeySuccess(apiKeyRevision));
    } catch (error) {
        let errorObject = errorHandler(error, "Get", "event api key details");
        yield put(actions.getEventApiKeyFailure(errorObject));
    }
}

export function* watchGetEventApiKeyRequest(api, { params }) {
    yield call(getEventApiKeyRequest, api, params);
}

export default function* ({ api }) {
    yield takeLatest(actions.GET_EVENT_API_KEY_REQUEST, watchGetEventApiKeyRequest, api);
}
